import CardCommon from '@op/components/CardCommon';
import LoadingCommon from '@op/components/LoadingCommon';
import { useHashtagDetailsKolList } from '@opm/pages/Hashtag/hooks';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import KolCard from '../KolCard';
import { throttle } from 'lodash-es';

interface IKolCardWrapperProps {
  detailsFilter: any;
  dropdownValue: string;
  selectedKol: Array<any>;
  setSelectedKol: (kols: { anchor_uid: string }) => void;
}
export default function KolCardWrapper(props: IKolCardWrapperProps) {
  const { detailsFilter, dropdownValue, selectedKol, setSelectedKol } = props;

  const scrollContainerRef = useRef<HTMLDivElement | null>(null);
  const [page, setPage] = useState<number>(1);

  const filterParams = useMemo(() => {
    const { categories, time_range, ...restFilter } = detailsFilter || {};
    return {
      ...restFilter,
      sort_by: dropdownValue,
      sort_order: 'desc',
      page,
      page_size: 20,
    };
  }, [detailsFilter, dropdownValue, page]);

  const {
    loadingRef,
    loading,
    kolList,
    hasMoreKol,
    setKolList,
    setHasMoreKol,
  } = useHashtagDetailsKolList({
    filter: filterParams,
  });

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;

    const onScroll = throttle(() => {
      const { scrollTop, clientHeight, scrollHeight } = container;
      if (
        scrollTop + clientHeight >= scrollHeight - 90 &&
        hasMoreKol &&
        !loadingRef.current
      ) {
        setPage((prev) => prev + 1);
      }
    }, 500);

    container.addEventListener('scroll', onScroll);
    return () => container.removeEventListener('scroll', onScroll);
  }, [hasMoreKol]);

  useEffect(() => {
    setPage(1);
    setKolList([]);
    setHasMoreKol(false);
  }, [detailsFilter, dropdownValue]);

  return (
    <CardCommon
      className="dbom-kols-cardCommon"
      contentCard
      empty={kolList.length === 0}
      loading={loading && page === 1}
      loadingHeight={120}
      emptyHeight={120}
      hasEmptyImg={false}
    >
      <div className="dbom-kols-list" ref={scrollContainerRef}>
        {kolList?.map((item: any, index: number) => {
          const isSelected = selectedKol.find(
            (kol) => kol.anchor_uid === item.anchor_uid,
          );
          return (
            <KolCard
              key={index}
              data={item}
              handleOnClick={(newKol) => setSelectedKol(newKol)}
              isSelected={isSelected}
            />
          );
        })}
        {loading && (
          <LoadingCommon
            status="loading"
            style={{ height: '30px' }}
          ></LoadingCommon>
        )}
      </div>
    </CardCommon>
  );
}
